<template>
  <div>
    <el-breadcrumb
      separator-class="el-icon-arrow-right"
      style="margin: 20px 0 20px 20px"
    >
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片视图 -->
    <el-card>
      <el-row :gutter="40">
        <el-col :span="20">
          <el-col :span="8">
            <el-input placeholder="请输入专业名称" v-model="queryInfo.name" clearable>
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" icon="el-icon-search" @click="searchFn"
              >查询</el-button
            >
          </el-col>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="addOrUpdateRole"
            >添加角色</el-button
          >
        </el-col>
      </el-row>
    </el-card>

    <!-- 用户列表展示 -->
    <div class="table">
      <el-table
        :data="roleList"
        border
        stripe
        style="width: 95%; margin: 10px auto"
      >
        <!-- 索引列 -->
        <el-table-column
          type="index"
          label="索引"
          width="50px"
        ></el-table-column>
        <el-table-column prop="id" label="角色ID"></el-table-column>
        <el-table-column prop="name" label="角色"></el-table-column>
        <el-table-column prop="status" label="是否启用" :formatter="statusFn"></el-table-column>
        <el-table-column prop="deleted" label="状态" :formatter="deletedFn"></el-table-column>
        <el-table-column prop="gmtCreate" label="创建时间" ></el-table-column>
        <el-table-column prop="gmtModified" label="更新时间"></el-table-column>
        <el-table-column label="操作">
          <!-- 利用自定义作用域插槽来解决在一个table-column里同时展示多个图标的问题 -->
          <template slot-scope="scope">
            <!-- 修改 -->
            <el-button
              type="primary"
              @click="addOrUpdateRole(scope.row)"
              icon="el-icon-edit"
              size="mini"
            ></el-button>
            <!-- 删除 -->
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="delFn(scope.row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页区域 -->
    <!-- size-change: 改变底部栏中m条/页的数据会触发 -->
    <!-- current-change: 当前页码值发生改变时会触发 -->
    <!-- page-sizes="[1, 2, 5, 10]: 1条/页 2条/页 5条/页 10条/页-->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.current"
      :page-sizes="[1, 2, 5, 10]"
      :page-size="queryInfo.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>

    <el-dialog
      :title="isUpdate ? '修改专业' : '添加专业'"
      :visible.sync="addDialogVisible"
      width="50%"
    >
      <el-form
        :model="addForm"
        :rules="addFormRules"
        ref="addFormRef"
        label-width="100px"
      >
        <el-form-item label="角色" prop="name">
          <!-- <el-input v-model="addForm.name" v-if="isUpdate" disabled></el-input> -->
          <el-input v-model="addForm.name" placeholder="请输入角色名"></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="statusStr">
           <el-select v-model="addForm.statusStr" placeholder="请选择">
              <el-option
                v-for="(item, i) in options"
                :key="i"
                :label="item[i]"
                :value="i">
              </el-option>
            </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addRole('addFormRef')"
          >确 定</el-button
        >
        <el-button @click="addDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import role from '../../api/adaptation'
export default {
  created() {
    this.getRoleList()
  },
  data() {
    return {
      // 获取用户列表参数(有模糊查询)
      queryInfo: {
        // 当query为null时默认查询所有人的数据
        //当前页数
        current: 1,
        //每一页展示的数据量
        size: 10,
        name: ''
      },
      total: 0,
      roleList: [],
      options: [
        {0: '是'},
        {1: '否'}
      ],
      // 是否展示提示框   
      addDialogVisible: false,
      // 添加用户的数据对象
      addForm: {
        name: '',
        statusStr: 0,
      },
      isUpdate: false,
      addFormRules: {
        name: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
        statusStr: [{ required: true, message: '请选择角色状态', trigger: 'blur' }],
      }
    };
  },
  methods: {
    statusFn (row) {
      return row.status ? '是' : '否'
    },
    deletedFn (row) {
      return row.deleted ? '删除' : '正常'
    },
    // 得到所有juese
    getRoleList() {
      let data = {
        current: this.queryInfo.current,
        size: this.queryInfo.size,
        name: this.queryInfo.name
      }
      role.getAllRole(data).then(res => {
        res.list.map((item, i) => {
          item.statusStr = item.status === true ? 0 : 1
          item.deletedStr = item.deleted === true ? 0 : 1
        })
        this.roleList = res.list
        this.total = res.total
      })
    },
    // 查询
    searchFn() {
      let data = {
        current: 1,
        size: this.queryInfo.size,
        name: this.queryInfo.name
      }
      role.getAllRole(data).then(res => {
        res.list.map((item, i) => {
          item.statusStr = item.status === true ? 0 : 1
          item.deletedStr = item.deleted === true ? 0 : 1
        })
        this.roleList = res.list
        this.total = res.total
      })
    },

    // 添加或者更新专业
    addOrUpdateRole(form) {
      let self = this
      self.addForm = {
        name: '',
        statusStr: 0
      }
      console.log(form)
      if (form.id) {
        self.addForm = JSON.parse(JSON.stringify(form))
        self.isUpdate = true
      }
      else
        self.isUpdate = false
      self.addDialogVisible = true
    },


    //监听底部分页栏 size 改变的事件
    handleSizeChange(newSize) {
      //console.log(newSize)
      this.queryInfo.size = newSize;
      this.getRoleList();
    },
    //监听底部分页面页码值发生改变的时间
    handleCurrentChange(newPage) {
      //console.log(newPage)
      this.queryInfo.current = newPage;
      this.getRoleList();
    },
    // 点击添加用户按钮时，给数据进行校验
    addRole(from) {
      console.log("this.addForm", this.addForm);
      this.$refs[from].validate(valid => {
        if (!valid) return
        let obj = {
          name: this.addForm.name,
          status: this.addForm.statusStr == 0 ? true : false
        }
        if (this.isUpdate) {
          obj.id = this.addForm.id,
          role.updateRole(obj).then(res => {
            this.$message({
              type: 'success',
              message: '修改成功!'
            });
            this.name = ''
            this.getRoleList();
            this.addDialogVisible = false
          })
        } else {
          role.addRole(obj).then(res => {
            this.$message({
              type: 'success',
              message: '添加成功!'
            });
            this.name = ''
            this.getRoleList();
            this.addDialogVisible = false
          })
        }

      })
    },
    delFn(row) {
      this.$confirm('此操作将永久删除该专业, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        role.deleteRoleById({id: row.id}).then(res => {
          this.getRoleList();
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  },
  filters: {
    
  }
};
</script>

<style lang="less" scoped>
.table {
  width: 100%;
  margin-top: -10px;
  background: #fff;
  padding: 20px 0;
}
</style>